/**
 * Created by seaasun on 2017/12/12.
 *
 *
 * errorType: 'default' 'custom' 'silent'
 * progressBar: true, false
 *
 */
import Vue from 'vue'
import config from '@/config'
import VueResource from 'vue-resource'
import utils from '@/assets/utils/index'
import notificaton from '@/components/common/notification'
Vue.use(VueResource)
export default Vue

let getLocal = function () { return 'hold' }
let apiName = config.dev.apiName
if (process.env.NODE_ENV === 'development') {
  import('./assets/dev/localApi').then(resp => {
    getLocal = resp.default
  })
}

let api = {
  local: '',
  unLogin: 'http://dev.sl360.com/login',
  login: utils.getRootPath()
}

Vue.http.options.root = api[apiName]

// Vue.http.headers.common['Access-Control-Allow-Credentials'] = 'true'
// Vue.http.headers.common['Cookie'] = '_acxm=8b4d2ade-a369-11e7-b85b-0ec41ab0532a; LPVID=hhMjc0N2JlMjUxZjdhMGFi; Hm_lvt_8875c662941dbf07e39c556c8d97615f=1510647647; _mkto_trk=id:982-LRE-196&token:_mch-sl360.com-1506663952710-21215; ASP.NET_SessionId=aeaio555e3ko4v55s1izscf1; _ga=GA1.2.2051064206.1506485374; _gid=GA1.2.1900188550.1514367031; _gat=1'

function filterDate (obj) {
  for (let key of Object.keys(obj)) {
    if (obj[key] instanceof Object) {
      obj[key] = filterDate(obj[key])
    } else if (typeof obj[key] === 'string' && obj[key].constructor === String && /\/Date\([0-9-]+\)+\//gi.test(obj[key])) {
      obj[key] = new Date(parseInt(/-?\d+/.exec(obj[key])[0]))
    }
  }
  return obj
}

function filterNull (obj) {
  for (let key of Object.keys(obj)) {
    if (obj[key] === null) {
      delete obj[key]
    } else if (obj[key] instanceof Object) {
      obj[key] = filterNull(obj[key])
    }
  }
  return obj
}

function defaultError (code, msg) {
  // Auth error
  if (code === 401 || code === 403) {
    alert('auth error') // TODO@PONY need to do auth

  // Server error
  } else if (code > 500) {
    msg = msg || 'Sorry, please try again'
    notificaton.notice('error', msg, {title: 'Server Error', onlyGroup: 'severError'})

  // time out
  } else if (code === 408) {
    notificaton.notice('error', 'Please check the internet connection', {title: 'Connect Error', onlyGroup: 'connectError'})

  // others
  } else {
    msg = msg || 'Sorry, please try again'
    notificaton.notice('error', 'Sorry for the server error. If you need help, please contact a Digital Expert at 800-399-8611.',
      {title: 'Server Error', onlyGroup: 'severError'})
  }
}
function handleError (resp, errorType, req) {
  // all custom rejcet
  if (errorType === 'silent') {
  // 400 - 599: defaul notice, else custom

  } else if (errorType === 'custom') {
    if (resp.status >= 400 && resp.status < 600) {
      defaultError(resp.status, resp.statusText)
    }

  // all use defaut notice
  } else if (errorType === 'default') {
    defaultError(resp.status, resp.statusText)
  }

  let info = {
    reqUrl: req.url,
    reqBody: req.body,
    reqParams: req.params,
    reqCrossOrigin: req.crossOrigin,
    reqHeaders: req.headers,
    respBody: resp.body,
    respStatusText: resp.statusText
  }
  utils.log('web', resp.status, resp.url, info)
}

// TODO@PONY need fix
Vue.http.interceptors.before = function (req, next) {
  // abort previous request, if exists
  if (req.hasOwnProperty('abortPre') && req.abortPre) {
    if (this.previousRequest) {
      this.previousRequest.abort()
    }
    this.previousRequest = req
  }
  next()
}
Vue.http.interceptors.push((req, next) => {
  if (!req.hasOwnProperty('progressBar')) {
    req.progressBar = true
  }
  if (req.progressBar) {
    utils.progressStart()
  }

  // delete param if null
  if (req.body) {
    req.body = filterNull(req.body)
  }
  // using local api when dev
  if (apiName === 'local') {
    if (getLocal() === 'hold') {
      setTimeout(() => {
        let body = getLocal(req.url)
        body = filterDate(body)
        if (req.progressBar) {
          utils.progressDone()
        }
        next(req.respondWith(body, {
          status: 200
        }))
      }, 3000)
    } else {
      let body = getLocal(req.url)
      body = filterDate(body)
      if (req.progressBar) {
        utils.progressDone()
      }
      next(req.respondWith(body, {
        status: 200
      }))
    }
  // using servers api
  } else {
    next(function (resp) {
      if (req.progressBar) {
        utils.progressDone()
      }
      // when resultFlag = flase, reject
      if (resp.body.d && resp.body.d.hasOwnProperty('ResultFlag') && resp.body.d.ResultFlag === false) {
        resp.ok = false
        resp.status = 900
        resp.statusText = resp.body.d.ResultMessage
      }
      // handle success
      if (resp.ok) {
        resp.body = filterDate(resp.body)
      // handle error
      } else {
        if (!req.hasOwnProperty('errorType')) {
          req.errorType = 'default'
        }
        handleError(resp, req.errorType, req)
      }
    })
  }
})



// WEBPACK FOOTER //
// ./src/http.js